
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/v-perfect",
      function () {
        return require("private-next-pages/pvc/v-perfect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/v-perfect"])
      });
    }
  